/**
 * Подпись вкладки браузера для страниц кабинета — из крошки самого глубокого маршрута
 * (`data.breadcrumb`: строка или `{label}`; `skip: true` и функции не берём). Явный
 * Angular-`title` маршрута важнее крошки. Чистая функция над деревом снимка роутера.
 */
export interface TitleRouteNode {
  data?: Record<string, unknown>;
  title?: string;
  firstChild?: TitleRouteNode | null;
}

export function routeTitleLabel(root: TitleRouteNode | null | undefined): string | null {
  let label: string | null = null;
  for (let node = root; node; node = node.firstChild) {
    label = (typeof node.title === 'string' && node.title) || crumbLabel(node.data?.['breadcrumb']) || label;
  }
  return label;
}

function crumbLabel(breadcrumb: unknown): string | null {
  if (typeof breadcrumb === 'string') {
    return breadcrumb || null;
  }
  if (breadcrumb && typeof breadcrumb === 'object') {
    const {label, skip} = breadcrumb as {label?: unknown; skip?: boolean};
    return !skip && typeof label === 'string' && label ? label : null;
  }
  return null;
}
